import _ from 'underscore';
import currencyConvertorTemplate from './currency-convertor-template.pug';

export function getCurrencyConvertorTemplateFromModel(
  i18n,
  model,
  importAccountCurrencyTitle
) {
  return options => (
    currencyConvertorTemplate(_.extend({
      externalAccountCurrency: model.AccountCurrencyMap.externalAccountCurrency,
      microsoftAccountCurrency: model.AccountCurrencyMap.microsoftAccountCurrency,
      importAccountCurrencyTitle,
      i18n,
    }, options))
  );
}
